import moment from "moment";
import Vue from "vue";

const TIME_BEFORE_EXPIRE = 300;

export default {
  state: {
    accessToken: '',
    expiresAt: '',
    refreshToken: ''
  },

  mutations: {
    SET_EXPIRES_AT (state, data) {
      if (data && data.expiresAt) {
        let duration = data.expiresAt - data.createdAt - TIME_BEFORE_EXPIRE;
        state.expiresAt = moment().add(duration, 's').unix();
        Vue.$log.debug('New access token expires at ' + state.expiresAt + ' in ' + duration + ' seconds');
      } else {
        state.expiresAt = 0;
      }
    },

    SET_ACCESS_TOKEN (state, accessToken) {
      state.accessToken = accessToken;
    },

    SET_REFRESH_TOKEN (state, refresh_token) {
      state.refreshToken = refresh_token;
    }
  },

  actions: {
    AUTH_ON_LOGIN (context, data) {
      context.commit('SET_EXPIRES_AT', { expiresAt: data.expiresAt, createdAt: data.createdAt});
      context.commit('SET_ACCESS_TOKEN', data.accessToken);
      context.commit('SET_REFRESH_TOKEN', data.refreshToken);

      if (data.rememberme) {
        localStorage.setItem('refreshToken', data.refreshToken);
      } else {
        sessionStorage.setItem('refreshToken', data.refreshToken);
      }
    },

    AUTH_CLEAR (context) {
      context.commit('SET_EXPIRES_AT', null);
      context.commit('SET_ACCESS_TOKEN', null);
      context.commit('SET_REFRESH_TOKEN', null);
      localStorage.clear();
      sessionStorage.clear();
    }
  },

  getters: {
    bearer: (state) => `Bearer ${state.accessToken}`,
    getRefreshToken: (state) => state.refreshToken || localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken') || '',
    isExpired: state => () => {
      return state.expiresAt < moment().unix();
    }
  }
}
